'use strict';

const $ = jQuery.noConflict();
import 'slick-carousel';

$(function() {
	const imageStrip = {
		sliderConfig: {
			centerMode: true,
			centerPadding: '120px',
			slidesToShow: 3,
			slidesToScroll: 1,
			autoplay: true,
			cssEase: 'ease-in-out',
			waitForAnimate: true,
			autoplaySpeed: 2300,
			pauseOnHover: true,
			speed: 700,
			arrows: true,
			infinite: true,
			swipe: true,
			rows: 0,
			responsive: [
				{
					breakpoint: 1199,
					settings: {
						centerPadding: '80px',
						slidesToShow: 3,
					}
				},
				{
					breakpoint: 991,
					settings: {
						centerPadding: '60px',
						slidesToShow: 3,
					}
				},
				{
					breakpoint: 767,
					settings: {
						centerPadding: '30px',
						slidesToShow: 1,
					}
				},
			],
		},

		init: function() {
			this.$sections = $('.image-strip');

			if (!this.$sections.length) {
				return;
			}

			this.$sections.each((_, section) => {
				this.initSection($(section));
			});

			$(window).on('load.imageStrip', this.refreshAll.bind(this));
			$(window).on('resize.imageStrip', this.debounceRefresh.bind(this));
		},

		initSection: function($section) {
			const $slider = $section.find('.js-image-strip-slider');
			const $wrap = $section.find('.image-strip__slider-wrap');
			const slideCount = $slider.children('.image-strip__item').length;

			if (!$slider.length || slideCount < 1 || $slider.hasClass('slick-initialized')) {
				return;
			}

			const state = {
				$slider: $slider,
				pendingSlide: null,
				isReady: false,
			};

			$slider.data('imageStripState', state);

			$slider.on('init.imageStrip breakpoint.imageStrip setPosition.imageStrip', (event, slick) => {
				this.onSetPosition(state, slick);
			});

			$slider.on('beforeChange.imageStrip', (event, slick, currentSlide, nextSlide) => {
				state.pendingSlide = nextSlide;
				this.applySlideClasses(state, slick, nextSlide);
			});

			$slider.on('afterChange.imageStrip', (event, slick) => {
				state.pendingSlide = null;
				this.applySlideClasses(state, slick, slick.currentSlide);
			});

			$slider.slick({
				...this.sliderConfig,
				prevArrow: $wrap.find('.js-image-strip-prev'),
				nextArrow: $wrap.find('.js-image-strip-next'),
			});
		},

		refreshAll: function() {
			$('.js-image-strip-slider.slick-initialized').each((_, slider) => {
				$(slider).slick('setPosition');
			});
		},

		debounceRefresh: function() {
			window.clearTimeout(this.resizeTimer);
			this.resizeTimer = window.setTimeout(this.refreshAll.bind(this), 150);
		},

		onSetPosition: function(state, slick) {
			const slideIndex = state.pendingSlide ?? slick.currentSlide;

			this.applySlideClasses(state, slick, slideIndex);

			if (!state.isReady) {
				state.isReady = true;
				window.requestAnimationFrame(() => {
					state.$slider.addClass('is-ready');
				});
			}
		},

		getSideClass: function(i, firstActive, lastActive, count) {
			const distRight = (i - lastActive - 1 + count) % count;
			const distLeft = (firstActive - i - 1 + count) % count;

			return distRight <= distLeft ? 'is-right' : 'is-left';
		},

		getSlideClasses: function(i, slideIndex, firstActive, lastActive, count) {
			if (i === slideIndex) {
				return 'is-center';
			}

			const isActive = lastActive >= firstActive
				? i >= firstActive && i <= lastActive
				: i >= firstActive || i <= lastActive;

			if (isActive) {
				return 'is-adjacent';
			}

			return `is-far ${this.getSideClass(i, firstActive, lastActive, count)}`;
		},

		applySlideClassToElement: function($el, newClasses, slideClasses) {
			if ($el.attr('data-slide-scale') === newClasses) {
				return;
			}

			$el.removeClass(slideClasses).addClass(newClasses);
			$el.attr('data-slide-scale', newClasses);
			this.toggleVideoPlayback($el, newClasses);
		},

		toggleVideoPlayback: function($el, newClasses) {
			const video = $el.find('.js-image-strip-video').get(0);

			if (!video) {
				return;
			}

			if (newClasses === 'is-center') {
				video.currentTime = 0;
				video.play().catch(() => {});
			} else {
				video.pause();
				video.currentTime = 0;
			}
		},

		applySlideClasses: function(state, slick, slideIndex) {
			const $slider = state.$slider;
			const $realSlides = $slider.find('.slick-slide:not(.slick-cloned)');
			const count = $realSlides.length;
			const slideClasses = 'is-center is-adjacent is-far is-right is-left';

			if (!count || typeof slideIndex !== 'number') {
				return;
			}

			const half = Math.floor(slick.options.slidesToShow / 2);
			const firstActive = (slideIndex - half + count) % count;
			const lastActive = (slideIndex + half) % count;

			$realSlides.each((i, slide) => {
				this.applySlideClassToElement(
					$(slide),
					this.getSlideClasses(i, slideIndex, firstActive, lastActive, count),
					slideClasses
				);
			});

			$slider.find('.slick-cloned').each((_, clone) => {
				const $clone = $(clone);
				const cloneIdx = parseInt($clone.attr('data-slick-index'), 10);
				const realIdx = ((cloneIdx % count) + count) % count;

				this.applySlideClassToElement(
					$clone,
					this.getSlideClasses(realIdx, slideIndex, firstActive, lastActive, count),
					slideClasses
				);
			});
		},
	};

	imageStrip.init();
});
